<template>
  <!-- 信息发布 -->
  <div class="page-solicitation">
    <!-- 表头搜索 -->
    <mySearchDict ref="mySearchDict" :showHilever="false" :pageType="`8`" @getParams="getHeadParams"></mySearchDict>

    <!-- 列表头部 -->
    <div class="com-list-header" style="display: none">
      <el-form class="com-search-box" ref="form" :model="form" label-width="60px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="标题 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="状态 :" prop="status">
              <el-select v-model="form.status" placeholder="请选择">
                <el-option v-for="item in statusList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item class="el-form-state" label="接收范围 :" prop="range">
              <el-select v-model="form.range" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item class="el-form-state" label="发布时间 :" prop="publishTime">
              <el-date-picker v-model="form.publishTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button" v-if="role == '2'">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;新增素材
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="素材图片" width="100">
            <template slot-scope="scope">
              <viewer :options="{ url: 'data-maxUrl' }">
                <img class="g-pointer" :src="scope.row.materialPicture"
                  :data-maxUrl="scope.row.materialPicture" alt :onerror="defaultImg"
                  style="width: 50px;">
              </viewer>
            </template>

            <!-- <template slot-scope="scope">{{ scope.$index+1 }}</template> -->
          </el-table-column>
          <el-table-column label="素材名称" min-width="15%" show-overflow-tooltip>
            <template slot-scope="scope">
              <router-link class="m-btn" target="_blank" :to="{path: '/staff/info-publish/detail', query: {id: scope.row.id}}">{{ scope.row.name }}</router-link>
            </template>
          </el-table-column>
          <el-table-column label="素材编号" min-width="15%">
            <template slot-scope="scope">
              <span>{{scope.row.code}}</span>
              <!-- <span>{{scope.row.code |  filterRang(that)}}</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="sourceName" label="素材来源" min-width="23%"></el-table-column>
          <el-table-column prop="sourceNumber" label="来源编号" min-width="14%">
            <template slot-scope="scope">
              <span>{{scope.row.sourceNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="typeDesc" label="类别" min-width="8%"></el-table-column>
          <el-table-column prop="yearDesc" label="年代" min-width="15%"></el-table-column>
          <el-table-column prop="creater" label="提取人" min-width="8%"></el-table-column>
          <el-table-column prop="createTime" label="提取时间" min-width="15%"></el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="16%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleAdd('detail', scope.row)">查看</a>

              <a class="m-btn mr-10" @click="handleAdd('edit', scope.row)" v-if="role == '2'">编辑</a>

              <a class="m-btn mr-10" @click="downLoad(scope.row)">下载</a>

              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)" v-if="role == '2'">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import mySearchDict from './my-search-dict'
export default {
  components: {
    mySearchDict
  },
  watch: {
    $route() {
      this.role = this.$route.query.role || '1' //1普通  2有新增权限
      this.initList()
    }
  },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      headParams: {
        collectTexture: '', // 质地类别
        collectDisablity: '', // 完残程度
        source: '', // 藏品来源
        qualityRange: '', // 质量范围
        enterCollectRange: '', // enterCollectRange
        collectType: '', // 藏品分类
        collectYear: '', // 藏品年代
        collectLevel: '', // 藏品级别
        isHigh: '', //是否高清图
      },
      role: '1',  //1普通  2有新增权限

      that: this,
      form: {
      },
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      // typeList: [{
      //   dictCode: '0',
      //   dictName: '全部'
      // }, {
      //   dictCode: '1',
      //   dictName: '正式志愿者'
      // }, {
      //   dictCode: '2',
      //   dictName: '预备志愿者'
      // }],
      typeList: [{
        dictCode: '0',
        dictName: '全部'
      }, {
        dictCode: '1',
        dictName: '正式志愿者'
      }, {
        dictCode: '2',
        dictName: '预备志愿者'
      }, {
        dictCode: '3',
        dictName: '学生志愿者'
      }, {
        dictCode: '4',
        dictName: '小志愿者'
      }],
      statusList: [{
        dictCode: '0',
        dictName: '未发布'
      }, {
        dictCode: '1',
        dictName: '已发布'
      }],
      tableData: [],
      listLoading: true,
    }
  },
  filters: {
    filterStatus(status) {
      if (status == 0) {
        return '未发布'
      } else if (status == 1) {
        return '已发布'
      }
      return
    },
    // filterRang(rang, self) {
    //   let obj = self.typeList.filter(item => {
    //     return item.dictCode == rang
    //   })

    //   if (obj && obj.length > 0) {
    //     return obj[0].dictName
    //   }

    //   return null
    // }
  },
  methods: {
    // 初始化表格
    initList() {
      this.listLoading = true
      this.tableData = []

      // this.$http
      //   .get('/bsInformationWeb/find', {
      //     informationId: this.detailId
      //   })
      //   .then(res => {
      //     if (res.success) {
      //       this.form = res.result
      //       if (res.result.img) {
      //         this.imgUrl = res.result.imgUrl
      //       }
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })
      // this.$api.volunteer.getNoticeList({
        // /collectmaterial/list?name=&type=&year=&currentPage=1&size=10
      this.$http.get('/collectmaterial/list', {
        // ...this.form,
        ...this.listQuery,
        // ...this.headParams,

        name: this.headParams.key,
        type: this.headParams.collectType,
        year: this.headParams.collectYear
      }).then(res => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        } else {
          this.$message.error(res.result.message)
        }
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })
      // this.$http
      //   .get('/bsInformation/list', {
      //     ...this.listQuery,
      //     ...this.form
      //   })
      //   .then(res => {
      //     this.listLoading = false
      //     if (res.success) {
      //       if (
      //         type === 'dele' &&
      //         this.listQuery.currentPage > 1 &&
      //         !res.result.length
      //       ) {
      //         this.listQuery.currentPage -= 1
      //         this.initList()
      //         return
      //       }
      //       this.tableData = res.result
      //       this.total = res.page.allRow
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })
    },

    handleAdd(type, item) {
      console.log(item)
      this.$router.push({
        path: '/data/manage/extract',
        query: {pageType: type, id: item && item.id}
      })
      // this.$refs['addCollect'].init('add')
    },

    // 获取头部参数
    getHeadParams(params) {
      // let f = 1
      // for (let k in params) {
      //   if (params[k]) {
      //     f = 0
      //   }
      // }
      // // 重置排序
      // if (f == 1) {
      //   this.$refs.tableRef.clearSort()
      // }
      this.listQuery.currentPage = 1
      this.headParams = params
      this.initList()
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['volunteer_identity_type', 'volunteer_recruit_status']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.typeList = firstArr.concat(state['volunteer_identity_type'])
            // this.statusList = firstArr.concat(state['volunteer_recruit_status'])
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 下载
    downLoad(item) {
      location.href = '/singleMuseum/collectmaterial/download?id=' + item.id
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          content: '该素材将被删除，请谨慎操作'
        }, () => {
          this.$http
            .get('/collectmaterial/delete', {
              id: id
            }).then(res => {
              if (res.success) {
                this.$message.success('素材删除成功')
                this.initList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    handlePublish(item) {
      this.$api.volunteer.publishNotice({ id: item.id, status: item.status == '0' ? '1' : '0' }).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.initList()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // handleCreate(type, id) {
    //   this.$refs.dialogCreateInfo.init(type, id)
    // },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },
  created() {
    this.role = this.$route.query.role || '1' //1普通  2有新增权限
    this.initList()
    // this.getDropdownValue()

    // window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.page-solicitation {
  width: 100%;
}
.el-form-state {
  /deep/ .el-form-item__label {
    width: 80px !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 80px !important;
  }
}
</style>